import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ProjectsService } from '../../../../core/projects.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../../../shared/components';
import { SiteMaterialTestService } from '../../../../../project/material-test/services/site-material-test.service';

@Component({
    selector: 'app-offsite-tests-summary',
    templateUrl: './offsite-tests-summary.component.html',
    styleUrls: ['./offsite-tests-summary.component.scss'],
    standalone: false
})
export class OffsiteTestsSummaryComponent implements OnInit, OnDestroy {
  @Input() projectId = '';

  total = 0;
  openCount = 0;
  closedCount = 0;
  loading = false;

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private projectsService: ProjectsService,
    private siteMaterialTestService: SiteMaterialTestService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    if (this.projectId) {
      this.fetchCounts();
    }
  }

  fetchCounts() {
    this.loading = true;
    this.siteMaterialTestService.getSummary('project', this.projectId)
      .then((summary: any) => {
        this.total = summary.total || 0;
        this.openCount = summary.open || 0;
        this.closedCount = summary.closed || 0;
      })
      .catch(() => {
        this.total = 0;
      })
      .finally(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  redirectToOffsiteTests(): void {
    const isFormDirty = this.projectsService.isAnyFormDirty.getValue();
    const doCloseAndNavigate = () => {
      this.projectsService.isAnyFormDirty.next(false);
      this.projectsService.closeRightPanel.next();
      this.router.navigate([`/offsite-tests/project/${this.projectId}`]);
    };
    if (!isFormDirty) {
      doCloseAndNavigate();
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: new ConfirmDialogModel(
        'Unsaved changes',
        'There are unsaved changes.<br/>Are you sure you want to discard?',
      ),
    });
    dialogRef.afterClosed().pipe(takeUntil(this.onDestroy)).subscribe((result: boolean) => {
      if (result) {
        doCloseAndNavigate();
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
